export default __webpack_public_path__ + "static/media/ru.b40b23ff.svg";